/* ER collectie-rail (2 nov 2026): scrollbalk met de Evan Red-lijn, pijlen, slepen aan de balk. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__err) return;
    root.__err = true;
    var rail = root.querySelector('[data-err-rail]'), list = rail && rail.querySelector('.err__list');
    var track = root.querySelector('[data-err-track]'), thumb = root.querySelector('[data-err-thumb]');
    var prev = root.querySelector('[data-err-prev]'), next = root.querySelector('[data-err-next]');
    if (!rail || !track || !thumb) return;
    var t = 0;

    function upd() {
      var max = rail.scrollWidth - rail.clientWidth, tw = track.clientWidth;
      var w = Math.max(56, tw * (rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1));
      var p = max > 0 ? rail.scrollLeft / max : 0;
      thumb.style.width = w.toFixed(1) + 'px';
      thumb.style.transform = 'translateX(' + ((tw - w) * p).toFixed(1) + 'px)';
      root.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }
    function stepWidth() {
      var card = rail.querySelector('.err__card');
      if (!card) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var one = card.getBoundingClientRect().width + gap;
      return one * Math.max(1, Math.floor((rail.clientWidth + gap) / one) - 1);
    }
    function go(dir) { rail.scrollBy({ left: dir * stepWidth(), behavior: reduce ? 'auto' : 'smooth' }); }

    rail.addEventListener('scroll', function () {
      if (!t) t = requestAnimationFrame(function () { t = 0; upd(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* Slepen aan de oranje lijn */
    var drag = null;
    thumb.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, s: rail.scrollLeft };
      try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
      rail.style.scrollSnapType = 'none';
      e.preventDefault();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var max = rail.scrollWidth - rail.clientWidth, room = track.clientWidth - thumb.offsetWidth;
      rail.scrollLeft = drag.s + (e.clientX - drag.x) * (room > 0 ? max / room : 0);
    });
    function end() { if (!drag) return; drag = null; rail.style.scrollSnapType = ''; }
    thumb.addEventListener('pointerup', end);
    thumb.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) {
      if (e.target.closest('[data-err-thumb]')) return;
      var r = track.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      rail.scrollTo({ left: p * (rail.scrollWidth - rail.clientWidth), behavior: reduce ? 'auto' : 'smooth' });
    });

    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
  }

  function boot() { document.querySelectorAll('[data-err]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-err]'); if (r) init(r); });
})();